import { createInertiaApp } from '@inertiajs/react';
import { router } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';
import './bootstrap';
import './index.css';
import { initSentry } from './observability/sentry';
import { AppErrorBoundary } from './components/shared/AppErrorBoundary';
import { trackEvent } from './api/analytics/trackEvent';

initSentry();

function trackPageView() {
  trackEvent({
    event_type: 'page.view',
    page_path: window.location.pathname,
    page_url: window.location.href,
    referrer: document.referrer || null,
  });
}

// Inertia fires `navigate` on initial page load and subsequent navigations,
// so a single listener covers both cases — no need for an explicit call.
router.on('navigate', trackPageView);

createInertiaApp({
  title: title => `${title} | MemoSlate`,
  resolve: name => {
    const pages = import.meta.glob('./pages/**/*.tsx', { eager: true });
    const adminPages = import.meta.glob('./admin/pages/**/*.tsx', { eager: true });

    if (name.startsWith('Admin/')) {
      const adminName = name.slice('Admin/'.length);
      return adminPages[`./admin/pages/${adminName}.tsx`];
    }
    return pages[`./pages/${name}.tsx`];
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <AppErrorBoundary>
        <App {...props} />
      </AppErrorBoundary>,
    );
  },
});
